import React from "react";

const skipSeconds = 5;
export function VideoJs(props: any) {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
    const { options, onReady, onTimeChange } = props;

  React.useEffect(() => {

      // Make sure Video.js player is only initialized once
      if (!playerRef.current) {
          // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
          const videoElement = document.createElement("video-js");

          videoElement.classList.add('vjs-big-play-centered');
          videoRef.current.appendChild(videoElement);
          // @ts-ignore
          const player = playerRef.current = videojs(videoElement, options, function() {
              player.defaultPlaybackRate(options.playbackRate);

              player.el().addEventListener('keydown', (e) => {
                  // Prevent conflicts with other shortcuts or if not focused
                  if (!player.hasClass('vjs-user-active')) return;

                  switch (e.key) {
                      case 'ArrowLeft':
                          player.currentTime(Math.max(0, player.currentTime() - skipSeconds));
                          e.preventDefault();
                          break;

                      case 'ArrowRight':
                          player.currentTime(Math.min(player.duration(), player.currentTime() + skipSeconds));
                          e.preventDefault();
                          break;
                  }
              });
              onReady && onReady(player);
          });
        player.on('timeupdate', () => {
            if (onTimeChange) {
                onTimeChange(player.currentTime());
            }
        });
          // You could update an existing player in the `else` block here
          // on prop change, for example:
      } else {
          const player = playerRef.current;

          player.autoplay(options.autoplay);
          player.src(options.sources);
      }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
      const player = playerRef.current;

      return () => {
          if (player && !player.isDisposed()) {
              player.dispose();
              playerRef.current = null;
          }
      };
  }, [playerRef]);

  return (
      <div data-vjs-player >
          <div ref={videoRef} />
      </div>
  );
}
